import React from "react";
import UserInfo from "../../components/UserInfo";
import { Select, Input, Button, Table, Pagination } from "antd";
import { SearchOutlined, FormOutlined, DeleteOutlined, } from '@ant-design/icons';
import './index.sass';
import api from "../../utils/api";
import Print from "./com/print";
import PrintPro from "../../components/ExportOrder/printPro";
import qs from "../../utils/qs";

const { Option } = Select;




export default class OrdersDelivery extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            ordersOptionsFlag: 0,
            printData: {},//打印
            exportParam: {},
            search_json: {},
            exportRules: {},
            printPro_show: false,
            load: true,
            page: 1,
            total: 0,
            dataSource: [

            ]
        }
    }



    componentDidMount() {

        this.get_delivery_list()

    }

    get_delivery_list = async (page = 1) => {//获取配送单列表-定时任务
        let param = {
            page,
            page_size: 10
        }
        this.setState({
            page
        })
        let res = await api('get-delivery-list', param);
        if (res.code === 200) {
            this.setState({
                dataSource: res.data,
                total: res.meta.paginate.total_count
            })
        }
        console.log(res)
    }

    printHandle = (type, exportType, exportData) => {//批量打印
        let { selectFlag } = this.state

        let printData = {
            title: '选择时间',
            visible: type === 'print',
            type: type,//print打印，，export导出
            text: '选择打印的订单类型',
            exportType,
            exportData,//导出的数据
        }

        //api接口未完成、、
        if (type === 'export' && selectFlag === 0) {
            this.setState({//api接口未完成、、
                printPro_show: true
            })
        } else {
            printData.visible = true
        }
        this.setState({
            printData: printData,
            load: true
        })
    }




    render() {

        let { ordersOptionsFlag, printData, exportParam, search_json, printPro_show, exportRules, dataSource, load, page, total } = this.stat;
        const columns = [
            {
                title: '汇总时刻',
                width: 250,
                dataIndex: 'task_desc',
                key: 'task_desc',
            },
            {
                title: '配送单号',
                width: 150,
                dataIndex: 'id',
                key: 'task_id',
            },

            // {
            //     title: '总件数',
            //     width: 150,
            //     dataIndex: 'product_num',
            //     key: 'product_num',
            // },
            // {
            //     title: '总单数',
            //     width: 150,

            //     dataIndex: 'order_num',
            //     key: 'order_num',
            // },
            // {
            //     title: '配送点数',
            //     width: 150,

            //     dataIndex: 'delivery_num',
            //     key: 'delivery_num',
            // },
            {
                title: '生成时间',
                dataIndex: 'execute_time',
                key: 'execute_time',
            },
            {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
            },
            {
                title: '状态',
                width: 100,

                render: (ctx) => {
                    return (
                        <p>
                            {qs.deliveryStatus(ctx.status)}
                        </p>
                    )
                }
            },
            {
                title: '操作',
                render: (ctx) => {
                    return (
                        <div className='flex'>
                            {/* <Link className='mgr10 pointer' to={`/order/deliveryDetail?id=${ctx['id']}`} >查看</Link> */}
                            {/* <p className='mgr10 pointer'>查看</p> */}
                            {/* <p className='mgr10 pointer' onClick={() => {
                                this.printHandle('print')
                            }}>打印</p> */}
                            <p className='mgr10 pointer' onClick={() => {
                                this.printHandle('export', 'orders', ctx.result)
                            }}>导出</p>
                            {/* <p className='mgr10 pointer'>已配送</p> */}
                            {/* <p className='mgr10 pointer'>删除</p> */}
                        </div>
                    )
                }
            },
        ];

        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            },
            getCheckboxProps: (record) => ({
                // Column configuration not to be checked
                name: record.name,
                props: {
                    defaultChecked: record.id === 1
                }
            }),
        };



        const rightBox = <ul className='flex'>
            <li>
                <label>全部商户</label>
                <p>26</p>
            </li>
            <li>
                <label>全部粉丝</label>
                <p>26</p>
            </li>
        </ul>


        const onChange = function () { }
        const onSearch = function () { }



        return (
            <div className='ordersDelivery'>
                <UserInfo rightBox={rightBox} />

                <div className='record mgtb20'>

                    <div className='change_fans flex'>

                        <div className='flex line alignCenter'>
                            配送单号：
                            <Input placeholder='配送单号：' />
                        </div>

                        <div className='flex line alignCenter'>
                            状态：
                            <Select
                                placeholder="全部"
                                optionFilterProp="children"
                                onChange={onChange}
                                onSearch={onSearch}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value="jack">全部</Option>
                                <Option value="lucy">已支付，待发货</Option>
                                <Option value="tom">待自提，待收货</Option>
                                <Option value="jack">支付失败</Option>
                                <Option value="lucy">已收货</Option>
                                <Option value="tom">已完成</Option>
                                <Option value="tom">取消订单</Option>
                                <Option value="lucy">退款失败</Option>
                                <Option value="tom">待退款</Option>
                                <Option value="tom">已退款</Option>
                            </Select>
                        </div>

                        <Button icon={<SearchOutlined />}>搜索</Button>

                        <Button>重置</Button>

                    </div>



                    <div className='change_fans'>
                        <div className='flex alignCenter screen mgb10'>
                            <ul className='flex ordersOptions'>
                                <li className={ordersOptionsFlag === 0 ? 'active' : ''}>全部</li>
                                <li className={ordersOptionsFlag === 1 ? 'active' : ''}>待配送</li>
                                <li className={ordersOptionsFlag === 2 ? 'active' : ''}>已配送</li>
                                <li className={ordersOptionsFlag === 3 ? 'active' : ''}>已删除</li>
                            </ul>

                            <div className='flex alignCenter'>
                                <Button icon={<FormOutlined />} className='themeBtn' size=''> 批量确认已配送</Button>
                                <Button icon={<DeleteOutlined />} className='themeBtn' size='' onClick={() => { this.show_export_handle() }}>批量删除</Button>
                            </div>
                        </div>
                        <Table rowSelection={{
                            ...rowSelection,
                        }} dataSource={dataSource} columns={columns} pagination={false} scroll={
                            {
                                scrollToFirstRowOnChange: false,
                                x: false
                            }
                        } />
                    </div>
                </div>


                <div className='page_style'>
                    <Pagination
                        page_size={10}
                        hideOnSinglePage={true}
                        onChange={(e) => { this.get_delivery_list(e) }}
                        defaultCurrent={1} showSizeChanger={false}
                        current={page}
                        total={total} />
                </div>


                {/* 打印 */}
                <Print
                    backTicket={e => { this.props.backTicket(e) }}
                    printSet={e => { this.setState({ printPro_show: e.showSet }) }}
                    printData={printData}
                    exportParam={exportParam}
                    searchJson={search_json}
                    load={load}
                    jump={(path, param) => { this.props.jump(path, param) }}>
                </Print>


                {
                    printPro_show ? (
                        <PrintPro
                            jumpUrl={e => { this.props.jumpUrl(e) }}
                            exportParam={exportParam}
                            printData={printData}
                            exportRules={exportRules}
                            showSet={e => { this.setState({ printPro_show: e }) }} />
                    ) : null
                }
            </div>
        )
    }
}